import { render } from "./IncomingParcels.vue?vue&type=template&id=439f549c&scoped=true"
import script from "./IncomingParcels.vue?vue&type=script&lang=js"
export * from "./IncomingParcels.vue?vue&type=script&lang=js"

import "./IncomingParcels.vue?vue&type=style&index=0&id=439f549c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439f549c"]])

export default __exports__